import type { ResponsiveImage } from '@lemonade-hq/uniclient-chat';
import { Layout, useViewportSize } from '@lemonade-hq/uniclient-theme';
import { useCallback } from 'react';
import * as styles from './CoverBackground.css';
import { getResponsiveBreakpoint } from './SpreadBackground';

interface BackgroundProps {
  readonly image: ResponsiveImage | string;
}

export const CoverBackground: React.FC<BackgroundProps> = ({ image }) => {
  const { isAboveDesktopViewport, isTabletViewport } = useViewportSize();

  const getResponsiveImage = useCallback(
    (responsiveImage: ResponsiveImage): string => {
      const viewport = getResponsiveBreakpoint(isAboveDesktopViewport, isTabletViewport);

      return responsiveImage[viewport] ?? responsiveImage.sm;
    },
    [isAboveDesktopViewport, isTabletViewport],
  );

  return (
    <Layout height="100%" position="absolute" top={0} width="100%" zIndex={-1}>
      <Layout
        left={styles.IMAGE_LEFT_POSITION}
        position="absolute"
        top={styles.IMAGE_TOP_POSITION}
        width="100vw"
        zIndex={-1}
      >
        <img
          alt="product background"
          className={styles.backgroundImage}
          height={styles.IMAGE_HEIGHT}
          src={typeof image === 'string' ? image : getResponsiveImage(image)}
          width="100%"
        />
      </Layout>
      <Layout
        backgroundColor="$backgroundSecondary"
        className={styles.backgroundLayer}
        height="100%"
        position="absolute"
        width="110vw"
        zIndex={-2}
      />
    </Layout>
  );
};
